import bulletimeCore from "./bulletime-core";

export default [bulletimeCore.pluginDef];
